(function () {
  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function toPixels(delta, mode) {
    // deltaMode: 0=pixel, 1=line, 2=page
    if (mode === 1) return delta * 16;
    if (mode === 2) return delta * window.innerHeight;
    return delta;
  }

  function initCarousel(carousel) {
    if (!carousel || carousel.dataset.initialized === 'true') return;
    carousel.dataset.initialized = 'true';

    const viewport = carousel.querySelector('.multirow-carousel__viewport');
    const slides = Array.from(carousel.querySelectorAll('.multirow-carousel__slide'));
    const dots = Array.from(carousel.querySelectorAll('.multirow-carousel__dot'));
    const prevBtn = carousel.querySelector('.multirow-carousel__arrow--prev');
    const nextBtn = carousel.querySelector('.multirow-carousel__arrow--next');

    if (!viewport || slides.length === 0) return;

    let activeIndex = 0;
    const mqDesktop = window.matchMedia('(min-width: 750px)');

    function updateArrows() {
      const shouldShow = slides.length > 1;

      [prevBtn, nextBtn].forEach((btn) => {
        if (!btn) return;
        if (!shouldShow) btn.setAttribute('hidden', '');
        else btn.removeAttribute('hidden');
      });

      if (prevBtn) {
        const disabled = activeIndex <= 0;
        prevBtn.disabled = disabled;
        prevBtn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      }

      if (nextBtn) {
        const disabled = activeIndex >= slides.length - 1;
        nextBtn.disabled = disabled;
        nextBtn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      }
    }

    function setActive(index) {
      activeIndex = index;

      if (dots.length) {
        dots.forEach((dot, i) => {
          if (i === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      updateArrows();
    }

    function scrollToIndex(index) {
      const i = clamp(index, 0, slides.length - 1);
      setActive(i);

      const targetLeft = slides[i].offsetLeft;
      viewport.scrollTo({ left: targetLeft, behavior: 'smooth' });
    }

    // Dots
    if (dots.length) {
      dots.forEach((dot) => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          const index = Number(dot.dataset.slide || 0);
          scrollToIndex(index);
        });
      });
    }

    // Arrows
    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        scrollToIndex(activeIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        scrollToIndex(activeIndex + 1);
      });
    }

    // Keyboard
    viewport.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      const next = e.key === 'ArrowRight' ? activeIndex + 1 : activeIndex - 1;
      scrollToIndex(next);
    });

    // ✅ Desktop wheel passthrough:
    // When user scrolls on the carousel, scroll the PAGE, not the carousel.
    // This guarantees section outside keeps moving.
    viewport.addEventListener(
      'wheel',
      (e) => {
        if (!mqDesktop.matches) return; // mobile keep default
        if (e.ctrlKey) return; // allow browser zoom gesture

        // Prevent the carousel from consuming wheel/trackpad scroll
        e.preventDefault();

        const dy = toPixels(e.deltaY, e.deltaMode);
        window.scrollBy({ top: dy, left: 0, behavior: 'auto' });
      },
      { passive: false }
    );

    // Active tracking
    const io = new IntersectionObserver(
      (entries) => {
        let best = { index: activeIndex, ratio: 0 };

        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const idx = slides.indexOf(entry.target);
          const ratio = entry.intersectionRatio;
          if (ratio > best.ratio) best = { index: idx, ratio };
        });

        if (best.ratio >= 0.6 && best.index !== activeIndex) {
          setActive(best.index);
        }
      },
      { root: viewport, threshold: [0.25, 0.4, 0.6, 0.75, 0.9] }
    );

    slides.forEach((slide) => io.observe(slide));

    // Initial
    setActive(0);
  }

  function initAll(root) {
    (root || document).querySelectorAll('.multirow-carousel').forEach(initCarousel);
  }

  document.addEventListener('DOMContentLoaded', () => initAll(document));
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
